import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import StorefrontIcon from "@mui/icons-material/Storefront";

import moment from "moment"; // Make sure moment is imported
import BadgeStatus from "../../../common/BadgeStatus";
import "./styles.css";

const WeekDaySchedule = ({
  day,
  getWeekDaysSites,
  getWeekDaysShifts,
  sites,
  activeSite,
  t,
  flag = "",
}) => {
  const shifts = getWeekDaysShifts(day);
  const sitesList = getWeekDaysSites(day).length
    ? getWeekDaysSites(day)
    : sites.filter((item) => item.id === activeSite).map((item) => item.name);

  // Check if the day is today
  const isToday = day.isSame(moment(), "day");

  // Calculate total overtime for the day (sum of all shifts)
  const totalOvertime = shifts.reduce(
    (sum, shift) => sum + (shift.total_overtime || 0),
    0
  );

  // Helper function to get background color based on status
  const getStatusColor = (status, isOngoing = false) => {
    if (isOngoing) return "#8e91d5"; // light blue for ONGOING
    if (status === 2) return "#28a745"; // green for ON_TIME
    if (status === 3) return "#ef4444"; // red for LATE
    if (status === 1) return "#5156be"; // bg-primary for ASSIGNED
    return "transparent";
  };

  // Helper function to determine if shift is ongoing
  const isShiftOngoing = (shiftData) => {
    return isToday && shiftData.time_in && !shiftData.time_out;
  };

  // Helper function to get display status
  const getDisplayStatus = (shiftData) => {
    if (isShiftOngoing(shiftData)) {
      return "Ongoing";
    }
    return shiftData.leave_type ? shiftData.leave_type : shiftData.status_name;
  };

  // Check if any shift in the day is ongoing
  const hasOngoingShift = shifts.some((shift) => isShiftOngoing(shift));

  return (
    <div
      className={`dashboard__weekschedule-item-container ${flag}`}
      style={{
        backgroundColor: hasOngoingShift ? "#e0e0f3" : "transparent",
      }}
    >
      {/* Day column */}
      <div className="dashboard__weekschedule-item-day">
        <p className="p1">{day.format("DD/M")}</p>
        <p className="p2">{day.format("ddd")}</p>
      </div>

      {/* Course column (left 65% + right 35%) */}
      <div className="dashboard__weekschedule-item-course">
        {/* Left column - shifts */}
        <div className="dashboard__weekschedule-item-course-time">
          {shifts.length > 0 ? (
            shifts.map((shiftData, index) => {
              const isOngoing = isShiftOngoing(shiftData);
              const statusColor = shiftData.leave_type
                ? "#ff6400b5"
                : getStatusColor(shiftData.status, isOngoing);

              return (
                <div key={index} className="dashboard__shift-card">
                  <div
                    className="dashboard__shift-accent"
                    style={{ backgroundColor: statusColor }}
                  ></div>
                  <div className="dashboard__shift-content">
                    {/* Shift name + time */}
                    <div
                      className="dashboard__shift-header"
                      style={{
                        backgroundColor: statusColor,
                      }}
                    >
                      {shiftData.shift} {shiftData.start_time} -{" "}
                      {shiftData.end_time}
                    </div>

                    <div className="schedule-items">
                      {/* Show time_in and time_out based on conditions */}
                      {isOngoing ? (
                        // Ongoing: show time_in with "..."
                        <div className="schedule-items-inside">
                          <AccessTimeIcon style={{ marginRight: 4 }} />
                          {shiftData.time_in} - ...
                        </div>
                      ) : (
                        // Not ongoing: show time_in and time_out if both exist
                        (shiftData.status === 2 || shiftData.status === 3) && (
                          <div className="schedule-items-inside">
                            <AccessTimeIcon style={{ marginRight: 4 }} />
                            {shiftData.time_in} - {shiftData.time_out}
                          </div>
                        )
                      )}

                      <div className="schedule-items-inside">
                        {" "}
                        <StorefrontIcon />
                        {sitesList.map((site, i) => (
                          <span key={i}> {site}</span>
                        ))}
                      </div>

                      {/* Overtime label */}
                      {totalOvertime > 0 && (
                        <div className="schedule-items-inside">
                          {" "}
                          <ChatBubbleOutlineOutlinedIcon
                            style={{ marginRight: 4 }}
                          />
                          Overtime - {totalOvertime} hours
                        </div>
                      )}

                      {/* Undertime label */}
                      {shiftData.is_undertime == true && (
                        <div className="schedule-items-inside">
                          <ChatBubbleOutlineOutlinedIcon
                            style={{ marginRight: 4 }}
                          />
                          Undertime
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // horizontally center (optional)
                alignItems: "center", // vertically center
                height: "100%", // make parent take full height
              }}
            >
              <p style={{ color: "#94B5C2", margin: "5%" }}>
                {t("No assigned shift")}
              </p>
            </div>
          )}
        </div>

        {/* Right column - bottom-right badge */}
        <div className="dashboard__weekschedule-item-course-time-right">
          <div className="dashboard__weekschedule-item-bottom-right">
            {shifts.length > 0 &&
              shifts.map((shiftData, index) => {
                const isOngoing = isShiftOngoing(shiftData);
                const statusColor = shiftData.leave_type
                  ? "#ff6400b5"
                  : getStatusColor(shiftData.status, isOngoing);
                const displayStatus = getDisplayStatus(shiftData);

                return (
                  <BadgeStatus
                    key={index}
                    style={{
                      borderRadius: "8px 0 8px 0", // top-left, top-right, bottom-right, bottom-left
                      backgroundColor: statusColor,
                      fontSize: "14px", // increase font size
                      fontWeight: 500, // optional: make it slightly bolder
                      padding: "6px 10px", // adjust padding if needed for larger text
                    }}
                    status={displayStatus}
                    t={t}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeekDaySchedule;
